import { render, staticRenderFns } from "./VendorSelect.vue?vue&type=template&id=96171ad8&"
import script from "./VendorSelect.vue?vue&type=script&lang=js&"
export * from "./VendorSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VAutocomplete,VContainer,VListItem,VListItemContent,VListItemSubtitle,VListItemTitle})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src879989930/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96171ad8')) {
      api.createRecord('96171ad8', component.options)
    } else {
      api.reload('96171ad8', component.options)
    }
    module.hot.accept("./VendorSelect.vue?vue&type=template&id=96171ad8&", function () {
      api.rerender('96171ad8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VendorSelect.vue"
export default component.exports